var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'isMobile': _vm.isMobile()},attrs:{"id":"tmg-io"}},[_c('SiteHeader',{class:{'filled': _vm.headerClass}}),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.shouldRenderFooter)?_c('SiteFooter',{attrs:{"isContactPage":_vm.isContactPage}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27793fd6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tmg-io.vue
// module id = null
// module chunks = 